export const MAX_RETURN_METRIC_PERCENT = 9999;

export function parseReturnMetricNumber(
  value: number | string | null | undefined,
): number | null {
  if (value === null || value === undefined || value === "" || value === "-") {
    return null;
  }
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.includes(" ") && isNaN(Number(trimmed))) {
      return null;
    }
    const num = Number(trimmed.replace("%", ""));
    return isFinite(num) ? num : null;
  }
  return isFinite(value) ? value : null;
}

export function isZeroOrMissingReturnMetric(
  value: number | string | null | undefined,
): boolean {
  const num = parseReturnMetricNumber(value);
  return num === null || num === 0;
}

export function isExcessiveReturnMetric(
  value: number | string | null | undefined,
): boolean {
  const num = parseReturnMetricNumber(value);
  return num !== null && Math.abs(num) > MAX_RETURN_METRIC_PERCENT;
}

export function shouldDisplayReturnMetricAsDash(
  value: number | string | null | undefined,
): boolean {
  return isZeroOrMissingReturnMetric(value) || isExcessiveReturnMetric(value);
}

export function getDisplayableReturnMetric(
  value: number | string | null | undefined,
): number | null {
  const num = parseReturnMetricNumber(value);
  if (num === null || shouldDisplayReturnMetricAsDash(num)) {
    return null;
  }
  return num;
}

export function formatSignedReturnMetricPercent(
  value: number | string | null | undefined,
): string {
  if (shouldDisplayReturnMetricAsDash(value)) {
    return "-";
  }
  const num = parseReturnMetricNumber(value);
  if (num === null) {
    return "-";
  }
  return `${num >= 0 ? "+" : "-"}${Math.abs(num).toFixed(2)}%`;
}

export function formatCAGR(cagr: number | string | null | undefined): string {
  if (shouldDisplayReturnMetricAsDash(cagr)) {
    return "-";
  }
  const num = parseReturnMetricNumber(cagr);
  if (num === null) {
    return "-";
  }
  return `${num >= 0 ? "+" : "-"}${Math.abs(num).toFixed(2)}%`;
}
